module.exports = __webpack_public_path__ + "static/media/ar_right_mobile.84672fd6.svg";